import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { Card, Col, Row } from 'react-bootstrap';
import { getOrderAllData } from 'nursd-dashboard/api/order';
import CustomerOrderLog from './orderTable/CustomerOrderLog';

const Orders = () => {
  const { authToken } = useAuth();
  const [customerOrderList, setCustomerOrderList] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);

  const getCustomer = async () => {
    setLoadingScreen(true);
    try {
      const order = await getOrderAllData(authToken);
      setCustomerOrderList(order);
      setLoadingScreen(false);
    } catch (error) {
      setCustomerOrderList([]);
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    getCustomer();
  }, [authToken]);

  return (
    <>
      <>
        {loadingScreen ? (
          <div className="m-3">
            <p>Loading...</p>
          </div>
        ) : customerOrderList?.length === 0 ? (
          <div className="m-3">
            <Row>
              <Col>
                <p>Order No Data Available</p>
              </Col>
            </Row>
          </div>
        ) : (
          <Card.Body className="bg-body-tertiary px-1 pb-1 pt-0 fs-10">
            <CustomerOrderLog customerOrderList={customerOrderList} />
          </Card.Body>
        )}
      </>
    </>
  );
};

Orders.propTypes = {};

export default Orders;
